import React, { Component } from "react";

import LocalizedStrings from "react-localization";
import en from "../../../localization/localization-en.json";
let strings = new LocalizedStrings({ en });

class RecommendationLink extends Component {
  state = {};
  render() {
    if (this.props.recommendation.url === "") {
      return <div />;
    }
    return (
      <a
        className="btn_visit_site"
        href={this.props.recommendation.url}
        target="_blank"
      >
        <button
          className="btn btn_primary btn_yaystack mb-2 mt-2 width_100"
          href={this.props.recommendation.url}
          style={{ zIndex: "1", fontFamily: "DIN Pro Bold" }}
        >
          {strings.visit_site}
        </button>
      </a>
    );
  }
}

export default RecommendationLink;



// WEBPACK FOOTER //
// ./src/components/recommendation/recommendation_interface/recommendation_link.jsx